import { render } from "./PaginationTool.vue?vue&type=template&id=45d77ee1"
import script from "./PaginationTool.vue?vue&type=script&lang=js"
export * from "./PaginationTool.vue?vue&type=script&lang=js"

import "./PaginationTool.vue?vue&type=style&index=0&id=45d77ee1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__